import { Nullish } from './common.types'
import { BaseTableRequest } from './table.types'
import { User, UserUpdater } from './user.types'

export enum CertificateType {
  BY_LESSONS = 'BY_LESSONS',
  BY_COURSES = 'BY_COURSES',
  BY_TIME = 'BY_TIME',
}

export interface Certificate {
  id: number
  name: string
  type: CertificateType
  timeSpent: number
  createdAt: string
  user: {
    firstname: string
    lastname: string
  }
  pdfFile: {
    mediaFileId: string
  }
}

export interface CertificateRule {
  id: number
  name: string
  type: CertificateRuleType
  courseIds: number[]
  lessonIds: number[]
  note: Nullish<string>
  isPublished: boolean
  deletedAt: Nullish<string>
  createdAt: Nullish<string>
  updatedAt: Nullish<string>
  publishedAt: Nullish<string>
  creator: Nullish<UserUpdater>
  updater: Nullish<UserUpdater>
}

export enum CertificateRuleType {
  BY_LESSONS = 'BY_LESSONS',
  BY_COURSES = 'BY_COURSES',
  BY_TIME = 'BY_TIME',
}

export const CertificateRuleTypeLabel = {
  [CertificateRuleType.BY_LESSONS]: 'By Lessons',
  [CertificateRuleType.BY_COURSES]: 'By Courses',
  [CertificateRuleType.BY_TIME]: 'By Time',
}

export interface CertificateRuleCreateRequest {
  name: string
  type: CertificateRuleType
  courseIds: number[]
  lessonIds: number[]
  note?: string
}

export interface CertificateRuleEditRequest {
  id: number
  name?: string
  type?: CertificateRuleType
  courseIds?: number[]
  lessonIds?: number[]
  note?: string
  isPublished?: boolean
}

export interface CertificateHistoryRequest extends BaseTableRequest {
  params: { id: number }
}

export interface CertificateHistoryRow {
  id: number
  name: string
  action: string
  field: string
  newValue: string | number
  oldValue: string | number
  createdAt: string
  updatedAt: string
  updater: User
}
